"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorGraphLineDefault = exports.ColorGraphBarDefault = exports.ColorGraphTextDefault = exports.ColorSubjectDroppedOut = exports.ColorSubjectCompleted = exports.ColorSubjectOngoing = exports.ColorSubjectScreeningFailed = exports.ColorSubjectScreening = exports.ColorSubjectEnroll = exports.ColorsDefault = void 0;
exports.ColorsDefault = ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"];
exports.ColorSubjectEnroll = "#fee6ce";
exports.ColorSubjectScreening = "#e8c1a0";
exports.ColorSubjectScreeningFailed = "#f47560";
exports.ColorSubjectOngoing = "#f1e15b";
exports.ColorSubjectCompleted = "#61cdbb";
exports.ColorSubjectDroppedOut = "#e8a838";
exports.ColorGraphTextDefault = "#000000";
exports.ColorGraphBarDefault = "#cfcfcf";
exports.ColorGraphLineDefault = "#000000";
//# sourceMappingURL=color.js.map